import styled from 'styled-components';

export const Wrapper = styled.div`
    border-radius: 32px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.root.colors.background['02Second']};
    border: 1px solid ${(theme) => theme.theme.root.colors.basicColors['8%']};
    margin-bottom: 5px;
`;

export const ScrollableList = styled.div`
    display: flex;
    gap: 8px;
    padding: 6px 9px;
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
        height: 4px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: ${({ theme }) => theme.root.colors.basicColors['30%']};
        border-radius: 4px;
    }

    @media (max-width: 600px) {
        width: 350px;
    }

    @media (max-width: 450px) {
        width: 250px;
    }
`;

export const ReactionButton = styled.button`
    background: transparent;
    border: none;
    user-select: none;
    font-size: 24px;
    line-height: 36px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    position: relative;

    transition: transform 0.15s ease;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 50%;
        background: ${(props) => props.theme.root.colors.basicColors['6%']};
        opacity: 0;
        transition: opacity 0.15s ease;
        z-index: -1;
    }

    &:hover {
        transform: scale(1.3);

        &::before {
            opacity: 1;
        }
    }

    &:active {
        transform: scale(1.5);

        &::before {
            opacity: 1;
        }
    }
`;
